import { Link, usePage } from "@inertiajs/react"
import { Flex, Text } from "@radix-ui/themes"

import type { NavItem } from "@/types"

export function NavMain({ items = [] }: { items: NavItem[] }) {
  const page = usePage()

  // Sort items by href length (descending) so more specific matches are checked first
  const sortedItems = [...items].sort((a, b) => b.href.length - a.href.length)

  return (
    <Flex direction="column" gap="2" p="2">
      <Text size="2" weight="medium" color="gray">
        Platform
      </Text>
      <Flex direction="column" gap="1">
        {items.map((item) => {
          // Find the matching item from sorted list - first match wins
          const matchingItem = sortedItems.find((sortedItem) =>
            page.url.startsWith(sortedItem.href),
          )
          const isActive = matchingItem === item
          return (
            <Link
              key={item.title}
              href={item.href}
              className={`relative flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors ${
                isActive
                  ? "border-l-2 border-blue-600 bg-blue-50 text-blue-700 dark:bg-blue-950 dark:text-blue-300"
                  : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
              }`}
            >
              {item.icon && (
                <item.icon
                  className={`h-4 w-4 ${isActive ? "text-blue-600 dark:text-blue-400" : ""}`}
                />
              )}
              <span className={isActive ? "font-medium" : ""}>{item.title}</span>
            </Link>
          )
        })}
      </Flex>
    </Flex>
  )
}
